import ApiService from '@/common/api/api.service';

let apiBasePath = 'Faturamento';
const FaturamentoService = {
  async excluirFaturamento(id) {
    return await ApiService.delete(`${apiBasePath}/${id}`);
  },
  async cancelarFaturamento(id) {
    return await ApiService.delete(
      `${apiBasePath}/cancelar-faturamento?id=${id}`
    );
  },
  async realizarFaturamento(id) {
    return await ApiService.post(
      `${apiBasePath}/realizar-faturamento?periodoContabilId=${id}`
    );
  },
  async liberarFaturamento(id) {
    return await ApiService.patch(
      `${apiBasePath}/liberar-faturamento?id=${id}`
    );
  },
  async bloquearFaturamento(id) {
    return await ApiService.patch(
      `${apiBasePath}/bloquear-faturamento?id=${id}`
    );
  },
  async listarFaturamentosPorAno(ano, paginacao) {
    let { data } = await ApiService.get(`${apiBasePath}`, {
      params: { ano: ano, ...paginacao },
    });

    return data;
  },
};

export default FaturamentoService;
